export default "__VITE_ASSET__DZRHP8GX__"